// extracted by mini-css-extract-plugin
export var center = "contact-module--center--3rgwT";
export var container = "contact-module--container--2JTbG";
export var error = "contact-module--error--3oNd8";
export var formSet = "contact-module--formSet--DbQ6w";
export var hCaptcha = "contact-module--hCaptcha--3yfwv";
export var spin = "contact-module--spin--pVMJs";
export var textInput = "contact-module--textInput--1lnHj";